import dashboard from './menu/dashboard'
import administrator from './menu/administrator'
import rolePermission from './menu/rolePermission'
import company from './menu/company'
import senior from './menu/senior'
import master from './menu/master'
import agent from './menu/agent'
import player from './menu/player'
import assistant from './menu/assistant'
import transaction from './menu/transaction'
import balanceReport from './menu/balanceReport'
import liveBetting from './menu/liveBetting'
import baccaratLive from './menu/baccaratLive'
import parley from './menu/parley'
import requestDeposit from './menu/requestDeposit'
import requestWithdraw from './menu/requestWithdraw'
import betSetting from './menu/betSetting'
import baccaratResult from './menu/baccaratResult'
import loyalty from './menu/loyalty'
import bank from './menu/bank'
import matchVideo from './menu/matchVideo'
import report from './menu/report'
import vvipReport from './menu/vvipReport'

export default [
  ...dashboard,
  ...administrator,
  ...rolePermission,
  ...liveBetting,
  ...baccaratResult,
  ...baccaratLive,
  ...parley,
  ...company,
  ...senior,
  ...master,
  ...agent,
  ...player,
  ...assistant,
  ...transaction,
  ...balanceReport,
  ...report,
  ...vvipReport,
  ...requestDeposit,
  ...requestWithdraw,
  ...betSetting,
  ...loyalty,
  ...bank,
  ...matchVideo,
]
